import React, { useEffect, useState } from "react";
import axios from "axios";
import api, { API_URL, showAlert } from "../util/api";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../header";
import Footer from "../footer";


const ConsultationCompletion = () => {
    /* -----------------------------
       State
    ------------------------------*/

    const [loading, setLoading] = useState(false);
    const [confirmed, setConfirmed] = useState(false);
    const [draftSaved, setDraftSaved] = useState(false);
    const router = useNavigate();




    const [form, setForm] = useState({
        casesummary: {
            primary: "",
            secondary: "",
        },
        consultationNotes: "",
        recommendations: [
            {
                action: "",
                priority: "",
                timeline: "",
                notes: "",
            },
        ],
        outcome: "",
    });



    const { appointment_id } = useParams();

    const draftKey = `consultation_draft_${appointment_id}`;


    /* -----------------------------
       Load Draft on Mount
    ------------------------------*/
    useEffect(() => {
        const savedDraft = localStorage.getItem(draftKey);
        if (savedDraft) {
             setForm(JSON.parse(savedDraft));
        }
    }, [draftKey]);

    /* -----------------------------
       Auto-Save Draft (Debounced)
    ------------------------------*/
    useEffect(() => {
        const timer = setTimeout(() => {
            localStorage.setItem(draftKey, JSON.stringify(form));
            setDraftSaved(true);

            setTimeout(() => setDraftSaved(false), 1500);
        }, 1000);

        return () => clearTimeout(timer);
    }, [form, draftKey]);

    /* -----------------------------
       Helpers
    ------------------------------*/
    const updateField = (path, value) => {
        setForm(prev => {
            const updated = { ...prev };
            let ref = updated;
            const keys = path.split(".");
            keys.slice(0, -1).forEach(k => (ref = ref[k]));
            ref[keys[keys.length - 1]] = value;
            return updated;
        });
    };

    const updateRecommendation = (i, field, value) => {
        const copy = [...form.recommendations];
        copy[i][field] = value;
        setForm({ ...form, recommendations: copy });
    };

    const addRecommendation = () => {
        setForm(prev => ({
            ...prev,
            recommendations: [
                ...prev.recommendations,
                { action: "", priority: "", timeline: "", notes: "" }
            ]
        }));
    };

    const removeRecommendation = index => {
        setForm({
            ...form,
            recommendations: form.recommendations.filter((_, i) => i !== index)
        });
    };

    /* -----------------------------
       Submit Final
    ------------------------------*/
    const handleSubmit = async () => {
        if (!confirmed || !form.casesummary.primary || !form.consultationNotes || !form.outcome) {
            showAlert("error", "error", "Please complete all required fields.");
            return;
        }

        try {
            alert(JSON.stringify(form)); 
            setLoading(true);
            let response = await api.post(
                `${API_URL}/consultations/${appointment_id}/complete`,
                form
            );

            if (response.data.status === "success") {
                // Clear draft permanently
                localStorage.removeItem(draftKey);

                showAlert("success", "successful", "Consultation submitted successfully");

                router("/appointment/" + appointment_id);



            } else {
                //alert(response.data.message);

                showAlert("error", 'error', response.data.message);
            }


        } catch (error) {
            showAlert("error", "error", "Failed to complete consultation");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchStatus = async () => {

            /* try { */
               const res = await api.get(
                  `${API_URL}/consultations/${appointment_id}/check`
              );
  
              if (res.data.status === "success") {
                  setForm(res.data.data);
  
                  localStorage.removeItem(draftKey);
              } 
            /*  } catch (err) {
                 console.error("Failed to fetch consultation status");
             } */
        };

        fetchStatus();
    }, []);


    /* -----------------------------
       UI
    ------------------------------*/
    return (

        <>

            <Navbar menuColor="red" />

            <section style={{ marginTop: "3cm" }}>




                <div className="container my-5">
                    <button
                        onClick={() => router(`/appointment/${appointment_id}`)}
                        style={{
                            background: "transparent",
                            border: "none",
                            color: "#007bff",
                            cursor: "pointer",
                            fontSize: 16,
                            padding: 0,
                        }}
                    >
                        ← Back
                    </button>
                    <div className="card shadow-lg border-0">
                        <div className="card-header bg-primary text-white">
                            <h4 className="mb-0">Case Summary</h4>
                        </div>

                        <div className="card-body">

                            {/* Draft Indicator */}
                            {draftSaved && (
                                <div className="alert alert-info py-2">
                                    💾 Draft auto-saved
                                </div>
                            )}

                            {/* Diagnosis */}
                            <section className="mb-4">
                                <h5 className="border-bottom pb-2">Case Summary</h5>
                                <div className="row g-3">

                                    <div className="col-md-6">
                                        <label className="form-label">
                                            Primary Legal Matter *


                                        </label>
                                        <input
                                            className="form-control"
                                            placeholder="e.g. Divorce, Property dispute, Employment issue"
                                            value={form.casesummary.primary}

                                            onChange={(e) =>
                                                updateField("casesummary.primary", e.target.value)
                                            }
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label">
                                            Secondary Legal Matter
                                        </label>
                                        <input
                                            className="form-control"
                                            placeholder="Optional"
                                            value={form.casesummary.secondary}
                                            onChange={(e) =>
                                                updateField("casesummary.secondary", e.target.value)
                                            }
                                        />
                                    </div>

                                </div>
                            </section>


                            {/* Consultation Notes */}
                            <section className="mb-4">
                                <h5 className="border-bottom pb-2">
                                    Consultation Notes *
                                </h5>

                                <textarea
                                    className="form-control"
                                    rows="4"
                                    placeholder="Provide consultation details, facts presented, legal concerns, lawyer observations, etc."
                                    value={form.consultationNotes}
                                    onChange={(e) =>
                                        updateField("consultationNotes", e.target.value)
                                    }
                                />
                            </section>



                            {/* Legal Advice / Recommendations */}
                            <section className="mb-4">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h5>Legal Advice / Recommended Actions</h5>

                                    <button
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={addRecommendation}
                                    >
                                        + Add
                                    </button>
                                </div>

                                {form.recommendations.map((r, i) => (
                                    <div key={i} className="card mb-3">
                                        <div className="card-body">
                                            <div className="row g-3">

                                                <div className="col-md-6">
                                                    <input
                                                        className="form-control"
                                                        placeholder="Recommended Action"
                                                        value={r.action}
                                                        onChange={(e) =>
                                                            updateRecommendation(
                                                                i,
                                                                "action",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>

                                                <div className="col-md-3">
                                                    <select
                                                        className="form-select"
                                                        value={r.priority}
                                                        onChange={(e) =>
                                                            updateRecommendation(
                                                                i,
                                                                "priority",
                                                                e.target.value
                                                            )
                                                        }
                                                    >
                                                        <option value="">
                                                            Select Priority
                                                        </option>
                                                        <option value="HIGH">
                                                            High
                                                        </option>
                                                        <option value="MEDIUM">
                                                            Medium
                                                        </option>
                                                        <option value="LOW">
                                                            Low
                                                        </option>
                                                    </select>
                                                </div>

                                                <div className="col-md-3">
                                                    <input
                                                        className="form-control"
                                                        placeholder="Timeline"
                                                        value={r.timeline}
                                                        onChange={(e) =>
                                                            updateRecommendation(
                                                                i,
                                                                "timeline",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>

                                                <div className="col-12">
                                                    <textarea
                                                        className="form-control"
                                                        rows="2"
                                                        placeholder="Advice details / legal instructions"
                                                        value={r.notes}
                                                        onChange={(e) =>
                                                            updateRecommendation(
                                                                i,
                                                                "notes",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            {form.recommendations.length > 1 && (
                                                <div className="text-end mt-2">
                                                    <button
                                                        className="btn btn-sm btn-danger"
                                                        onClick={() =>
                                                            removeRecommendation(i)
                                                        }
                                                    >
                                                        Remove
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </section>





                            {/* Consultation Outcome */}
                            <section className="mb-4">
                                <h5 className="border-bottom pb-2">
                                    Consultation Outcome *
                                </h5>

                                <select
                                    className="form-select"
                                    value={form.outcome}
                                    onChange={(e) =>
                                        updateField("outcome", e.target.value)
                                    }
                                >
                                    <option value="">
                                        Select outcome
                                    </option>

                                    <option value="ADVICE_PROVIDED">
                                        Legal advice provided
                                    </option>

                                    <option value="FOLLOW_UP_REQUIRED">
                                        Follow-up consultation required
                                    </option>

                                    <option value="DOCUMENT_REVIEW">
                                        Document review required
                                    </option>

                                    <option value="CASE_ACCEPTED">
                                        Case accepted for representation
                                    </option>

                                    <option value="REFERRED">
                                        Referred to another lawyer
                                    </option>

                                    <option value="NO_ACTION_REQUIRED">
                                        No further action required
                                    </option>
                                </select>
                            </section>

                            {/* Confirmation */}
                            <div className="form-check mb-4">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={confirmed}
                                    onChange={e => setConfirmed(e.target.checked)}
                                />
                                <label className="form-check-label">
                                      I confirm this legal consultation is complete and final
                                </label>
                            </div>

                            {/* Submit */}
                            <div className="text-end">
                                <button
                                    className="btn btn-success btn-lg"
                                    disabled={loading}
                                    onClick={handleSubmit}
                                >
                                    {loading ? "Completing Consultation..." : "Complete Consultation"}
                                </button>
                            </div>

                        </div>


                    </div>
                </div>

            </section>

            <Footer />

        </>
    );
};

export default ConsultationCompletion;
